var render = function render(){var _vm=this,_c=_vm._self._c;return _c('V2Layout',[_c('div',{staticClass:"v2-agd"},[_c('OriginalComponent',_vm._b({key:_vm.$route.fullPath},'OriginalComponent',_vm.routeProps,false))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }